<template>
  <v-container fluid grid-list-md text-xs-center style="min-height: 93.4vh">
    <v-layout row wrap>
      <v-toolbar class="main-tool-bar">
        <v-layout
          py-2
          ma-0
          row
          :wrap="$vuetify.breakpoint.xsOnly"
          justify-start
          align-center
          align-content-start
        >
          <v-flex shrink mr-5>
            <v-toolbar-title>Estadísticas</v-toolbar-title>
          </v-flex>
          <v-flex shrink>
            <v-menu
              v-model="modalF"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  id="first"
                  :value="momentFormatFirst"
                  label="Fecha de inicio"
                  prepend-icon="event"
                  hide-details
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                header-color="primary"
                color="secondary"
                locale="es-419"
                v-model="timeFirst"
                scrollable
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex shrink ml-auto>
            <v-btn flat color="primary" @click="beginGraphics">Generar</v-btn>
            <v-btn flat color="primary" @click="downloadAll"
              >Descargar todo</v-btn
            >
          </v-flex>
        </v-layout>
      </v-toolbar>
      <v-container
        fluid
        elevation-2
        style="max-height: 75vh"
        class="scrollDesign"
      >
        <v-layout row wrap>
          <v-flex xs12 sm6 md6 lg6>
            <v-card class="expandableContainer elevation-0">
              <div div class="chart-container" style="height: 50vh">
                <canvas
                  id="canvaStdByLevel"
                  style="width: 100%; height: 100%"
                ></canvas>
              </div>

              <v-card-title primary-title>
                <v-container fluid pl-2 pr-2 pb-2 pt-0>
                  <v-layout>
                    <v-flex flexbox>
                      <span class="headline">Alumnos por nivel</span>
                    </v-flex>
                  </v-layout>
                </v-container>
                <div>
                  <div>
                    Reporte de asistencia de alumnos de la institución,
                    agrupados por niveles (Los niveles presentados son los que
                    reportaron asistencia).
                  </div>
                </div>
              </v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-tooltip right>
                  <!-- <v-btn icon ripple slot="activator" to="reports/details">
										<v-icon color="primary">remove_red_eye</v-icon>
									</v-btn>-->
                  <span>Detalles</span>
                </v-tooltip>
                <v-btn
                  flat
                  color="primary"
                  @click="
                    downloadGraphic('Asistencia por nivel', 'canvaStdByLevel')
                  "
                  >Descargar Gráfica</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex xs12 sm6 md6 lg6>
            <v-card class="expandableContainer elevation-0">
              <div div class="chart-container" style="height: 50vh">
                <canvas
                  id="canvaStdByDoor"
                  style="width: 100%; height: 100%"
                ></canvas>
              </div>

              <v-card-title primary-title>
                <v-container fluid pl-2 pr-2 pb-2 pt-0>
                  <v-layout>
                    <v-flex flexbox>
                      <span class="headline"
                        >Alumnos entregados por puerta</span
                      >
                    </v-flex>
                  </v-layout>
                </v-container>
                <div>
                  <div>
                    Visualización de la cantidad de alumnos que han sido
                    entregados por puerta durante un día (Las puertas
                    presentadas son las que reportaron asistencia).
                  </div>
                </div>
              </v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-tooltip right>
                  <!-- <v-btn icon ripple slot="activator" to="reports/details">
										<v-icon color="primary">remove_red_eye</v-icon>
									</v-btn>-->
                  <span>Detalles</span>
                </v-tooltip>
                <v-btn
                  flat
                  color="primary"
                  @click="
                    downloadGraphic('Entregas por puerta', 'canvaStdByDoor')
                  "
                  >Descargar Gráfica</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex xs12 sm6 md6 lg6>
            <v-card class="expandableContainer elevation-0">
              <div div class="chart-container" style="height: 50vh">
                <canvas
                  id="canvaStdByStatus"
                  style="width: 100%; height: 100%"
                ></canvas>
              </div>

              <v-card-title primary-title>
                <v-container fluid pl-2 pr-2 pb-2 pt-0>
                  <v-layout>
                    <v-flex flexbox>
                      <span class="headline">Estatus de alumnos</span>
                    </v-flex>
                  </v-layout>
                </v-container>
                <div>
                  <div>
                    Visualización de la cantidad de alumnos que han sido
                    cancelados, o se encuentran en estado de solicitado,
                    entregado o en camino.
                  </div>
                </div>
              </v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-tooltip right>
                  <!-- <v-btn icon ripple slot="activator" to="reports/details">
										<v-icon color="primary">remove_red_eye</v-icon>
									</v-btn>-->
                  <span>Detalles</span>
                </v-tooltip>
                <v-btn
                  flat
                  color="primary"
                  @click="
                    downloadGraphic('Estatus de alumnos', 'canvaStdByStatus')
                  "
                  >Descargar Gráfica</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex xs12 sm6 md6 lg6>
            <v-card class="expandableContainer elevation-0">
              <div div class="chart-container" style="height: 50vh">
                <canvas
                  id="canvaStdByCar"
                  style="width: 100%; height: 100%"
                ></canvas>
              </div>

              <v-card-title primary-title>
                <v-container fluid pl-2 pr-2 pb-2 pt-0>
                  <v-layout>
                    <v-flex flexbox>
                      <span class="headline">Medios de transporte</span>
                    </v-flex>
                  </v-layout>
                </v-container>
                <div>
                  <div>
                    Visualización de los medios de transporte que han sido
                    seleccionados al solicitar alumnos, sin tomar en
                    consideración si el alumno está solicitado, en camino,
                    entregado o cancelado.
                  </div>
                </div>
              </v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-tooltip right>
                  <!-- <v-btn icon ripple slot="activator" to="reports/details">
										<v-icon color="primary">remove_red_eye</v-icon>
									</v-btn>-->
                  <span>Detalles</span>
                </v-tooltip>
                <v-btn
                  flat
                  color="primary"
                  @click="
                    downloadGraphic('Medios de transporte', 'canvaStdByCar')
                  "
                  >Descargar Gráfica</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
        <confirm
          :class="!confirm.value ? 'position-no' : ''"
          :value="confirm.value"
          :title="confirm.title"
          :description="confirm.description"
        ></confirm>

        <!--v-on:desition="desitionDelete"-->
        <loading v-model="working.wLoading" text="Trabajando"></loading>
        <success v-model="toast.success" text="Operación Exitosa"></success>
        <error v-model="toast.failed" text="Ups ocurrió un error"></error>
      </v-container>
    </v-layout>
  </v-container>
</template>
<script>
import Chart from 'chart.js'
import jsPDF from 'jspdf'
import moment from 'moment'
import { mapGetters } from 'vuex'
import confirm from '../../Dialogs/Confirm'
import error from '../../Dialogs/Error'
import loading from '../../Dialogs/Loading'
import success from '../../Dialogs/Success'
export default {
  components: {
    confirm,
    loading,
    success,
    error,
  },
  props: [],
  data: () => ({
    timeFirst: new Date().toISOString().substr(0, 10),
    menu: false,
    modalF: false,
    modalL: false,
    menu2: false,
    confirm: {
      value: false,
      title: '',
      description: '',
      show: false,
    },
    toast: {
      success: false,
      failed: false,
    },
    working: {
      wLoading: false,
    },
    report: {},
    data: {
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [
        {
          label: 'My First dataset',
          backgroundColor: 'rgb(255, 99, 132)',
          borderColor: 'rgb(255, 99, 132)',
          data: [0, 10, 5, 2, 20, 30, 45],
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
            },
          },
        ],
      },
    },
    backgroundColor: [
      'rgba(0,0,128,0.5)',
      'rgba(128,0,0,0.5)',
      'rgba(255,255,0, 0.5)',
      'rgba(0,128,0, 0.5)',
      'rgba(255,0,255, 0.5)',
    ],
    borderColor: [
      'rgba(0,0,128,0.7)',
      'rgba(128,0,0,0.7)',
      'rgba(255,255,0, 0.7)',
      'rgba(0,128,0, 0.7)',
      'rgba(255,0,255, 0.7)',
    ],
    borderWidth: 2,
    typeChart: 'bar',
    chart: {},
    status: {
      D: 'Entregado',
      Q: 'En espera',
      R: 'Solicitado',
      X: 'Cancelado',
      C: 'En camino',
    },
    transport: { cByCar: 'Carro', cByWalk: 'Caminando' },
    bunchCanva: [],
    bunchChar: [],
  }),
  created() {},
  mounted() {
    this.beginGraphics()
  },
  watch: {
    getBranch() {},
  },
  methods: {
    beginGraphics() {
      Chart.defaults.global.legend.display = false
      this.countByLevels()
      this.countByDoor()
      this.countByStatus()
      this.countByCar()
    },

    countByLevels() {
      this.$store
        .dispatch(
          'stats/countStudentsByLevel',
          moment(this.timeFirst).format('YYYY-MM-DD')
        )
        .then((response) => {
          var newLabels = []
          var newData = []
          for (const [index, item] of response.data.entity.entries()) {
            newLabels.push(item.typeLevel)
            newData.push(item.nStudents)
          }
          var data = {
            labels: newLabels,
            datasets: [
              {
                backgroundColor: this.backgroundColor,
                borderColor: this.borderColor,
                borderWidth: this.borderWidth,
                data: newData,
              },
            ],
          }
          var ctx = document.getElementById('canvaStdByLevel').getContext('2d')
          ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height)
          if (this.bunchChar[0]) {
            this.bunchChar[0].destroy()
          }
          this.bunchCanva[0] = document.getElementById('canvaStdByLevel')
          ctx.webkitImageSmoothingEnabled = false
          ctx.mozImageSmoothingEnabled = false
          ctx.imageSmoothingEnabled = false
          this.bunchChar[0] = new Chart(ctx, {
            type: this.typeChart,
            data: data,
            options: this.options,
          })
          this.bunchChar[0].update()
        })
        .catch((error) => {
          this.toast.failed = true
          console.log(error)
        })
    },

    countByDoor() {
      this.$store
        .dispatch(
          'stats/transactionByDoor',
          moment(this.timeFirst).format('YYYY-MM-DD')
        )
        .then((response) => {
          var newLabels = []
          var newData = []
          for (const [index, item] of response.data.entity.entries()) {
            newLabels.push(item.doorName)
            newData.push(item.nStudents)
          }
          var data = {
            labels: newLabels,
            datasets: [
              {
                backgroundColor: this.backgroundColor,
                borderColor: this.borderColor,
                borderWidth: this.borderWidth,
                data: newData,
              },
            ],
          }

          var ctx = document.getElementById('canvaStdByDoor').getContext('2d')
          ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height)
          if (this.bunchChar[1]) {
            this.bunchChar[1].destroy()
          }
          this.bunchCanva[1] = document.getElementById('canvaStdByDoor')
          ctx.webkitImageSmoothingEnabled = false
          ctx.mozImageSmoothingEnabled = false
          ctx.imageSmoothingEnabled = false
          this.bunchChar[1] = new Chart(ctx, {
            type: this.typeChart,
            data: data,
            options: this.options,
          })
          this.bunchChar[1].update()
        })
        .catch((error) => {
          this.toast.failed = true
          console.log(error)
        })
    },

    countByStatus() {
      this.$store
        .dispatch(
          'stats/transactionByStatus',
          moment(this.timeFirst).format('YYYY-MM-DD')
        )
        .then((response) => {
          var newLabels = []
          var newData = []
          for (const [index, item] of response.data.entity.entries()) {
            // console.log(item)
            newLabels.push(this.status[item.status])
            newData.push(item.nStudents)
          }
          var data = {
            labels: newLabels,
            datasets: [
              {
                backgroundColor: this.backgroundColor,
                borderColor: this.borderColor,
                borderWidth: this.borderWidth,
                data: newData,
              },
            ],
          }
          var ctx = document.getElementById('canvaStdByStatus').getContext('2d')
          ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height)
          if (this.bunchChar[2]) {
            this.bunchChar[2].destroy()
          }
          this.bunchCanva[2] = document.getElementById('canvaStdByStatus')
          ctx.webkitImageSmoothingEnabled = false
          ctx.mozImageSmoothingEnabled = false
          ctx.imageSmoothingEnabled = false
          this.bunchChar[2] = new Chart(ctx, {
            type: this.typeChart,
            data: data,
            options: this.options,
          })
          this.bunchChar[2].update()
        })
        .catch((error) => {
          this.toast.failed = true
          console.log(error)
        })
    },
    countByCar() {
      this.$store
        .dispatch(
          'stats/transactionByCar',
          moment(this.timeFirst).format('YYYY-MM-DD')
        )
        .then((response) => {
          var newLabels = []
          var newData = []
          for (const [index, item] of Object.entries(response.data.entity)) {
            newLabels.push(this.transport[index])
            newData.push(item)
          }
          var data = {
            labels: newLabels,
            datasets: [
              {
                backgroundColor: this.backgroundColor,
                borderColor: this.borderColor,
                borderWidth: this.borderWidth,
                data: newData,
              },
            ],
          }

          var ctx = document.getElementById('canvaStdByCar').getContext('2d')
          ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height)
          if (this.bunchChar[3]) {
            this.bunchChar[3].destroy()
          }
          this.bunchCanva[3] = document.getElementById('canvaStdByCar')
          ctx.webkitImageSmoothingEnabled = false
          ctx.mozImageSmoothingEnabled = false
          ctx.imageSmoothingEnabled = false
          this.bunchChar[3] = new Chart(ctx, {
            type: this.typeChart,
            data: data,
            options: this.options,
          })
          this.bunchChar[3].update()
        })
        .catch((error) => {
          this.toast.failed = true
          console.log(error)
        })
    },
    loadImageAsDataURL(url) {
      return new Promise((resolve, reject) => {
        img.onload = function () {
          var canvas = document.createElement('canvas')
          var ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0)
          resolve(canvas.toDataURL())
        }
        img.onerror = reject
        img.src = url
      })
    },
    downloadGraphic(type, canvas) {
      this.working.wLoading = true
      var canvas = document.getElementById(canvas)

      //creates image
      var canvasImg = canvas.toDataURL('image/png')

      const months = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ]
      var headers = []
      var bodyTable = []
      let doc = new jsPDF('landscape')
      let branch = this.getBranch
      let fDate =
        new Date(this.timeFirst).getDate() +
        '/' +
        months[new Date(this.timeFirst).getMonth()] +
        '/' +
        new Date(this.timeFirst).getFullYear()

      var pdfName = type
      var header = function (data) {
        // doc.setFont("helvetica");
        // doc.setFontType("bold");
        // doc.setFontSize(25);
        doc.text(branch.name, 55, 15)
        // doc.setFont("helvetica");
        // doc.setFontSize(13);
        // doc.text(type, 55, 25);
        // doc.text("Día: " + fDate, 55, 35);
        var splitTitle = doc.splitTextToSize(branch.address, 400)
        var y = 45
        for (var i in splitTitle) {
          doc.text(splitTitle[i], 55, y)
          y += 5
        }
        var img = new Image()

        if (branch.img != null && branch.img != '') {
          var imgData =
            branch.img == null ? '' : 'data:image/png;base64, ' + branch.img
          img.onload = function () {
            doc.addImage(imgData, 'PNG', data.settings.margin.left, 10, 30, 30) //(imagen,formato,x-pos,y-pos, width,heigth)
          }
        }

        var width = doc.internal.pageSize.getWidth()
        var widthNoMargins = width - data.settings.margin.left
        var pos = (widthNoMargins - 200) / 2
        doc.addImage(canvasImg, 'PNG', pos, 60, 200, 120)
      }
      doc.autoTable({
        head: [headers],
        margin: {
          top: 120,
        },
        styles: {
          fontSize: 10,
          verticalcell: 60,
          cellWidth: 'grid',
        },
        columnStyles: {
          0: {
            fontSize: 15,
          },
        },
        didDrawPage: header,
      })

      doc
        .save(type + '.pdf', { returnPromise: true })

        .then((res) => {
          // console.log(res);
          this.working.wLoading = false
          this.toast.success = true
        })
        .catch((err) => {
          console.log(err)
          this.working.wLoading = false
          this.toast.failed = true
        })
    },

    downloadAll() {
      var textBody = [
        ['Alumnos por nivel'],
        [
          'Reporte de asistencia de alumnos de la institución, agrupados por niveles (Los niveles presentados son los que reportaron asistencia).',
        ],
        ['Alumnos entregados por puerta'],
        [
          'Visualización de la cantidad de alumnos que han sido entregados por puerta durante un día (Las puertas presentadas son las que reportaron asistencia).',
        ],
        ['Estatus de alumnos'],
        [
          'Visualización de la cantidad de alumnos que han sido cancelados, o se encuentran en estado de solicitado, entregado o en camino.',
        ],
        ['Medios de transporte'],
        [
          'Visualización de los medios de transporte que han sido seleccionados al solicitar alumnos, sin tomar en consideración si el alumno está solicitado, en camino, entregado o cancelado.',
        ],
      ]
      var imgMessures = { x: 220, y: 120 }
      var oldTop = 0
      this.working.wLoading = true
      var images = []
      var canvasImgs = []
      for (var a in this.bunchCanva) {
        canvasImgs.push(this.bunchCanva[a].toDataURL('image/png'))
      }

      const months = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ]
      var headers = []
      var bodyTable = []
      let doc = new jsPDF('landscape')
      let branch = this.getBranch
      let dObj = new Date(this.timeFirst + ' 00:00')
      let fDate =
        dObj.getDate() +
        '/' +
        months[dObj.getMonth()] +
        '/' +
        dObj.getFullYear()

      var header = function (data) {
        // doc.setFont("helvetica");
        // doc.setFontType("bold");
        // doc.setFontSize(25);
        doc.text(branch.name, 55, 15)
        // doc.setFont("helvetica");
        // doc.setFontSize(13);
        // doc.text("Reporte general de entregas", 55, 30);
        // doc.text("Día: " + fDate, 55, 35);
        var splitTitle = doc.splitTextToSize(branch.address, 400)
        var y = 22
        for (var i in splitTitle) {
          doc.text(splitTitle[i], 55, y)
          y += 5
        }
        var img = new Image()

        if (branch.img != null && branch.img != '') {
          var imgData =
            branch.img == null ? '' : 'data:image/png;base64, ' + branch.img
          img.onload = function () {
            doc.addImage(imgData, 'PNG', data.settings.margin.left, 10, 30, 30) //(imagen,formato,x-pos,y-pos, width,heigth)
          }
        }
      }
      doc.autoTable({
        body: textBody,
        margin: {
          top: 43,
        },
        styles: {
          fontSize: 10,
          verticalcell: 60,
          cellWidth: 'grid',
        },
        columnStyles: {
          0: {
            fontSize: 15,
          },
        },
        willDrawCell: function (data) {
          // console.log(data)
          if (data.section == 'body' && data.row.index % 2 == 0) {
            // doc.setFontSize(15);
            // doc.setFontType("bold");
            if (data.pageNumber == 1) data.row.height = imgMessures.y + 15
            else data.row.height = imgMessures.y + 40
          } else if (data.section == 'body') {
            // doc.setFontSize(13);
            // doc.setFontType("normal");
            data.row.height = imgMessures.y + 40
          }
        },
        didDrawCell: function (data) {
          if (data.section == 'body' && data.row.index % 2 == 0) {
            images.push({
              elem: canvasImgs[data.row.index / 2],
              x: data.cell.x + 10,
              y: data.cell.y + 10,
            })
          }
        },

        didDrawPage: function (data) {
          if (data.pageNumber == 1) {
            header(data)
          }
          data.settings.margin.top = 11
          for (var i = 0; i < images.length; i++) {
            if (!images[i].isLoad) {
              doc.addImage(
                images[i].elem,
                images[i].x + 5,
                images[i].y + 5,
                imgMessures.x,
                imgMessures.y
              )
              images[i].isLoad = true
            }
          }
        },
      })

      doc
        .save('Reporte general.pdf', { returnPromise: true })
        .then((res) => {
          this.working.wLoading = false
          this.toast.success = true
        })
        .catch((err) => {
          console.log(err)
          this.working.wLoading = false
          this.toast.failed = true
        })
    },

    createPDF(action, type) {
      const months = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ]
      var headers = []
      var bodyTable = []
      let doc = new jsPDF('p', 'pt')
      let branch = this.getBranch
      let fDate =
        new Date(this.timeFirst).getDate() +
        +'/' +
        months[new Date(this.timeFirst).getMonth()] +
        '/' +
        new Date(this.timeFirst).getFullYear()
      let lDate =
        new Date(this.timeLast).getDate() +
        1 +
        '/' +
        months[new Date(this.timeFirst).getMonth()] +
        '/' +
        new Date(this.timeFirst).getFullYear()
      var pdfName = 'Reporte'
      var header = function (data) {
        doc.setFont('helvetica')
        doc.setFontType('bold')
        doc.setFontSize(25)
        doc.text('Colegio ' + branch.name, 150, 45)
        doc.setFont('helvetica')
        doc.setFontSize(13)
        doc.text(
          type == 'attendance' ? 'Reporte de Asistencia' : 'Reporte de Salida',
          150,
          70
        )
        doc.text('Periodo: ' + fDate + ' -- ' + lDate, 150, 115)
        var splitTitle = doc.splitTextToSize(branch.address, 400)
        var y = 90
        for (var i in splitTitle) {
          doc.text(splitTitle[i], 150, y)
          y += 12
        }
        if (branch.img != null && branch.img != '') {
          var imgData =
            branch.img == null ? '' : 'data:image/jpg;base64, ' + branch.img
          doc.addImage(imgData, 'JPEG', data.settings.margin.left, 10, 100, 100) //(imagen,formato,x-pos,y-pos, width,heigth)
        }
        doc.autoTable({
          head: [headers],
          margin: {
            top: 120,
          },
          styles: {
            fontSize: 10,
            verticalcell: 60,
            cellWidth: 'grid',
          },
          columnStyles: {
            0: {
              fontSize: 15,
            },
          },
          didDrawPage: header,
        })
      }

      //Headers
      headers[0] = 'Nombre'
      for (let g of this.reports.groups) {
        headers.push(g.name)
      }
      headers[headers.length] = 'Total'

      //Body
      for (let item of this.reports.levels) {
        for (const [index, grade] of item.grades.entries()) {
          var row = []
          row[0] = item.name + ' ' + grade.name
          for (const [index, item] of this.reports.groups.entries()) {
            forG: for (let a of grade.groups) {
              if (item.name == a.name) {
                row[index + 1] = a.attendance
                break forG
              }
            }
            row[index + 1] = row[index + 1]
          }
          row[row.length] = grade.totalByGrade

          bodyTable[bodyTable.length] = row
        }
        bodyTable[bodyTable.length] = [
          'Total de ' + item.name + ': ',
          item.totalByLevel,
        ]
      }
      bodyTable[bodyTable.length] = []
      bodyTable[bodyTable.length] = [
        'Total Estudiantes: ',
        this.reports.totalStudents,
      ]
      doc.autoTable({
        head: [headers],
        margin: {
          top: 120,
        },
        styles: {
          fontSize: 10,
          verticalcell: 60,
          cellWidth: 'grid',
        },
        columnStyles: {
          0: {
            fontSize: 15,
          },
        },
        didDrawPage: header,
        didParseCell: function (data) {
          if (data.cell.text[0].includes('Total')) {
            data.cell.styles.fillColor = [41, 128, 185]
            data.cell.styles.textColor = 255
            data.cell.styles.halign = 'center'
          }
        },
      })

      doc.save(pdfName + '.pdf')
    },
  },
  computed: {
    momentFormatFirst() {
      if (this.timeFirst != null) {
        return moment(this.timeFirst).format('DD/MM/YYYY')
      }
      return ''
    },
    momentFormatLast() {
      if (this.timeLast != null) {
        return moment(this.timeLast).format('DD/MM/YYYY')
      }
      return ''
    },
    ...mapGetters(['getBranch']),
  },
}
</script>
<style>
.no-padding {
  padding-left: 10%;
}
.position-no {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: -1;
}
.expandableContainer {
  border-style: solid !important;
  border-color: #e6e6e6 !important;
  border-radius: 15px !important;
  border-width: 2px !important;
}
</style>
<style scoped>
.main-tool-bar {
  z-index: 1;
}
/deep/ .main-tool-bar .v-toolbar__content {
  height: auto !important;
}
</style>
